import { useContext, useEffect, useRef, useState } from 'react';
import AppContext from 'AppContext';
import { down, up } from 'styled-breakpoints';
import styled, { css } from 'styled-components';
import { Nav } from 'components/base/nav';
import { Container } from 'components/base/view';

const HeaderContainer = styled.header`
  position: relative;
  padding: 0px;
  background-color: ${(props) => props.theme.colors.white};
  height: 700px;
  display: flex;
  justify-content: flex-start;
  max-width: 1400px;
  width: 100%;
}
  ${down('md')} {
    padding-bottom: 40px;
    height: fit-content;
  }
  ${down('sm')} {
    height: fit-content;
  }
`;

const HeaderContainerPlatform = styled(HeaderContainer)`
  height: 77px;
  width: 100%;
  max-width: 100%;
  ${down('md')} {
    padding-bottom: 0px !important;   
    overflow: unset;
  }
  ${down('sm')} {
    height: fit-content;
    overflow: unset;
    padding: 69px 0px 10px 0px;
    margin: 0px 10px 14px 10px !important;
    box-shadow: 0px 4px 4px ${(props) => props.theme.colors.gray15}};
    border-radius: 0px 0px 5px 5px;
  }
  margin-top: 40px;
`;

const HeaderImage = styled.div`
  ${(props) =>
    !props.backgroundImage &&
    `background-color: ${props.theme.colors.white18};`}
  ${(props) =>
    props.backgroundImage &&
    `background-image: url(${
      props.backgroundImage.startsWith('http')
        ? props.backgroundImage
        : `/images${props.backgroundImage}`
    });`}
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100%;
  width: 100%;
  margin-left: -250px;
  animation: fadeIn 1s;
  -ms-animation: fadeIn 1s;
  z-index: 0;
  transition: all 0.5s ease-out;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  box-sizing: border-box;
  margin-top: -50px;
  // use the md context to implemement hte below bracket
  ${down('md')} {
    margin-top: -65px;
    padding-right: 30px;
    padding-top: 40px;
  }
  img,
  h5 {
    display: flex;
    max-width: 500px;
    height: auto;
    align-self: center;
  }
  h5 {
    width: 100%;
    display: block;
    text-align: right;
    margin-top: 10px;
  }
  img {
    max-width: 650px;
  }
  a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.red4};
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-moz-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-o-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-ms-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const HeaderMonthlySponsor = styled.div`
  background-color: ${(props) => props.theme.colors.white18};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: calc(100% + 31px);
  background-size: 55%;
  width: 125%;
  margin-left: -219px;
  margin-top: -31px;
  ${down('xl')} {
    margin-left: -85px;
  }
  ${down('lg')} {
    margin-left: -30px;
  }
  ${down('sm')} {
    display: none;
  }
  animation: fadeIn 1s;
  -ms-animation: fadeIn 1s;
  z-index: 0;
  transition: all 0.5s ease-out;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-moz-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-o-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-ms-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const Image = styled.img`
  max-height: 500px;
`;
const Url = styled.a`
  letter-spacing: 2px;
`;
const UrlMeta = styled.h5`
  color: ${(props) => props.theme.colors.black10};
  font-size: 13px;
  margin-bottom: 40px;
  margin-top: 10px;
`;

const HeaderContent = styled(Container)`
  background: ${(props) => props.theme.colors.yellow4};
  position: relative;
  height: 100%;
  width: 70%;
  display: flex;
  color: ${(props) => props.theme.colors.black11};
  border-bottom-left-radius: 3px;
  z-index: 2;
  ${down('md')} {
    padding-bottom: 40px;
  }
  ${down('sm')} {
    width: 100%;
    height: calc(100% + 41px);
    background: ${(props) => props.theme.colors.yellow3};
  }
`;

const HeaderContentPlatform = styled(HeaderContent)`
  width: 73.17%;
  ${down('md')} {
    padding-bottom: 0px;
    width: 60%;
  }
  ${down('sm')} {
    width: 100%;
    background: ${(props) => props.theme.colors.white};
    padding: 0px;
  }
`;

const Navigation = styled(Nav)`
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 195px;
  left: 0px;
  @media screen and (max-width: 823px) {
    bottom: 195px;
  }
  ${(navProps) =>
    navProps.$isSticky &&
    css`
      position: fixed;
      top: 0px;
      right: 0px;
      bottom: auto;
      left: 0px;
      z-index: 100;
      width: 100vw;
      max-height: 80px;
      padding: 12px 5px;
      box-sizing: border-box;
      background: ${navProps.theme.colors.white};
      box-shadow: 0px 2px 8px ${navProps.theme.colors.gray11};
      pointer-events: none;

      nav {
        max-width: calc(100vw - 10px);
        pointer-events: auto;
      }

      nav li {
        margin-right: 8px;
      }

      nav li > a > span {
        box-shadow: none !important;
        padding: 9px 24px;
        white-space: nowrap;
      }

      nav ul ul li {
        margin-right: 0px;
      }

      nav ul ul li > a {
        padding: 8px 12px;
      }

      nav ul ul li > a > span {
        padding: 0px;
      }

      @media screen and (max-width: 900px) {
        padding-top: 10px;
        padding-bottom: 10px;

        nav li {
          margin-right: 4px;
        }

        nav li > a > span {
          font-size: 13px;
          letter-spacing: 0.4px;
          padding: 7px 12px;
        }

        nav .dropdown-caret {
          margin-left: 4px;
        }

        nav ul ul li > a {
          padding: 7px 10px;
        }

        nav ul ul li {
          margin-right: 0px;
        }

        nav ul ul li > a > span {
          padding: 0px;
        }
      }
    `}
`;

const NavigationPlatform = styled(Navigation)`
  width: auto;
  bottom: 0px;
  ${up('sm')} {
    nav {
      display: block;
    }
  }
  ${down('md')} {
    li {
      span {
        padding-left: 18px;
        padding-right: 18px;
      }
    }
  }
`;

const ComponentsContainer = styled(Container)`
  padding-bottom: 0px !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 450px;
  padding-left: 44px;
  box-sizing: border-box;
  ${down('md')} {
    padding-left: 25px;
    padding-right: 20px;
  }
  ${down('sm')} {
    width: 100%;
    height: auto;
  }
`;

const ComponentsContainerPlatform = styled(ComponentsContainer)`
  width: auto;
  padding-left: 14px;
  ${up('sm')} {
      justify-content: flex-end;
      margin-top: -16px;
      margin-right: 5px;
    }
  }
  ${down('md')} {
    padding-left: 14px;
  }
  ${down('sm')} {
    padding-left: 0px;
    width: 100%;
    display: ${(containerProps) =>
      containerProps.hideInMobile ? 'none' : 'inherit'};
  }
`;

const MonthlySponsorContainer = styled.div`
    display: flex;
    height: auto;
    align-self: center;
}
`;

export default function HeaderView(props) {
  const { platformApp } = useContext(AppContext);
  const headerRef = useRef(null);
  const navAnchorTopRef = useRef(0);
  const [isNavSticky, setIsNavSticky] = useState(false);

  const { showNavigation = false } = props;

  useEffect(() => {
    if (platformApp || !showNavigation) return undefined;

    const updateNavAnchorTop = () => {
      const headerElement = headerRef.current;
      const navElement = headerElement?.querySelector('nav');

      if (!headerElement || !navElement) return;

      navAnchorTopRef.current =
        headerElement.getBoundingClientRect().top +
        window.scrollY +
        headerElement.offsetHeight -
        195 -
        navElement.offsetHeight;
    };

    const updateStickyState = () => {
      if (!navAnchorTopRef.current) {
        updateNavAnchorTop();
      }

      setIsNavSticky(window.scrollY >= navAnchorTopRef.current);
    };

    const handleResize = () => {
      updateNavAnchorTop();
      updateStickyState();
    };

    updateNavAnchorTop();
    updateStickyState();
    window.addEventListener('scroll', updateStickyState, { passive: true });
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', updateStickyState);
      window.removeEventListener('resize', handleResize);
    };
  }, [platformApp, showNavigation]);

  return (
    <>
      {!platformApp && (
        <HeaderContainer
          id="header"
          ref={headerRef}
          className={props.className}
          {...props}
        >
          <HeaderContent className="HeaderContent">
            <ComponentsContainer className="ComponentsContainer">
              {props.content}
            </ComponentsContainer>
          </HeaderContent>
          <HeaderImage
            {...props}
            backgroundImage={props.backgroundImage}
            className="HeaderImage"
          >
            <Image alt="logo" src={props.image} />
            <UrlMeta>
              <Url target="_blank" href={props.url}>
                {props.urltitle}
              </Url>
              {props.urlmeta}
            </UrlMeta>
          </HeaderImage>
          {showNavigation ? (
            <Navigation $isSticky={isNavSticky} isSticky={isNavSticky} />
          ) : null}
        </HeaderContainer>
      )}
      {platformApp && (
        <HeaderContainerPlatform
          id="header"
          platformApp={platformApp}
          {...props}
          className={`${props.className} HeaderContainerPlatform`}
        >
          <HeaderContentPlatform className="HeaderContent">
            <ComponentsContainerPlatform>
              {props.content}
            </ComponentsContainerPlatform>
            {showNavigation ? (
              <ComponentsContainerPlatform hideInMobile>
                <NavigationPlatform>{props.nav}</NavigationPlatform>
              </ComponentsContainerPlatform>
            ) : null}
          </HeaderContentPlatform>
          <HeaderMonthlySponsor>
            <MonthlySponsorContainer>
              <div />
            </MonthlySponsorContainer>
          </HeaderMonthlySponsor>
        </HeaderContainerPlatform>
      )}
    </>
  );
}
